module.exports = __webpack_public_path__ + "img/375_stores_img2.c104dc7c.png";